/* eslint-disable import/no-relative-packages */

import React from 'react';
import {
  View, Text,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  Rating,
} from 'react-native-elements';
import AORTypes from '../../types';
import styles from '../../styles';

import PublisherIcon from './PublisherIcon';

import camera from '../../assets/images/glyphicons-camera.png';
import starStandard from '../../../node_modules/react-native-ratings/src/images/star.png'; // FIXME(clairbee): fix webpack config instead

import infraConfig from '../../config.json';

function ReviewBadge(props) {
  const {
    data, style,
  } = props;

  // console.log(props);
  let image = camera;
  const hasImage = data.image && data.image !== '' && data.image.substring !== undefined;
  if (hasImage) {
    const prefix = data.image.substring(6, 8)
      + data.image.substring(4, 6)
      + data.image.substring(2, 4)
      + data.image.substring(0, 2);
    // const prefix = data.uuid.substring(0, 8);
    // console.log(prefix);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);
    // console.log(index);
    image = { uri: `https://${infraConfig.userImagesThumbs64Bucket}.s3-${infraConfig.region}.amazonaws.com/${index}/${data.image}` };
  }

  return (
    <View style={[styles.reviewBadge.panel, style]}>
      <View style={styles.reviewBadge.imageBlockBackground}>
        <PublisherIcon
          style={{ width: 64, height: 64 }}
          loadingStyle={{ size: 'small', color: styles.primaryColor }}
          hasImage={hasImage}
          source={image}
        />
      </View>
      <View style={styles.reviewBadge.panelInner}>
        <Text style={styles.reviewBadge.name} numberOfLines={1} ellipsizeMode="tail">
          {data.name}
        </Text>
        <View style={styles.reviewBadge.panelRating}>
          <Rating
            type="custom"
            ratingImage={starStandard}
            imageSize={28}
            readonly
            startingValue={data.ratingApproved || data.rating || 0}
            style={styles.reviewBadge.rating}
          />
        </View>
        <Text style={styles.reviewBadge.review} ellipsizeMode="tail">
          {data.reviewApproved || data.review}
        </Text>
      </View>
    </View>
  );
}

ReviewBadge.defaultProps = {
  style: {},
};

ReviewBadge.propTypes = {
  data: AORTypes.Review.isRequired,
  style: ViewPropTypes.style,
};

export default ReviewBadge;
